import React, { useEffect } from 'react'
import { InputSelect as Select, IconErase } from '@Knowledge-OTP/znk-ui-components'
import { useSelector } from 'react-redux'
import useTranslation from '../../../../../i18n/useTranslation'
import escapeRegExp from 'lodash/escapeRegExp'
import { Collapse } from 'reactstrap'

const TopicSelectionTeaching = (props) => {
  const { selectionsArray, setSelectionsArray } = props
  const state = useSelector((state) => state)
  console.log(selectionsArray)
  console.log(state?.user?.services)
  // const services = useSelector((state) => state.user.services)
  const servicesArray = useSelector((state) => state.user.services)
  const { translate } = useTranslation()
  const services = React.useMemo(() => {
    return servicesArray.reduce((acc, s) => {
      acc[s.id] = s
      return acc
    }, {})
  }, [servicesArray])
  useEffect(() => {
    // Add a new empty selection if the last one is filled
    if (selectionsArray.length > 0) {
      const lastSelection = selectionsArray[selectionsArray.length - 1]
      if (lastSelection.serviceId && (lastSelection.topicId || !(services[lastSelection.serviceId]?.topics && Object.keys(services[lastSelection.serviceId].topics).length > 0))) {
        setSelectionsArray([...selectionsArray, { serviceId: null, topicId: null, }])
      }
    } else {
      // Start with one empty selection
      setSelectionsArray([{ serviceId: null, topicId: null, }])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionsArray, setSelectionsArray])

  const handleServiceChange = (index, serviceId) => {
    const newSelections = [...selectionsArray]
    newSelections[index] = { serviceId, topicId: null, }
    setSelectionsArray(newSelections)
  }

  const handleTopicChange = (index, topicId) => {
    const newSelections = [...selectionsArray]
    newSelections[index].topicId = topicId
    setSelectionsArray(newSelections)
  }

  const removeSelection = (index) => {
    if (selectionsArray.length > 1) {
      const newSelections = selectionsArray.filter((_, i) => i !== index)
      setSelectionsArray(newSelections)
    } else {
      // If it's the last one, just clear it
      setSelectionsArray([{ serviceId: null, topicId: null, }])
    }
  }

  return (
    <div className='p-0 m-0'>
      {selectionsArray.map((selection, index) => (
        <div key={index} className='mb-2 position-relative'>
          <div className='row'>
            <div className='col-6'>
              <span className='text-body'>
                {translate('profile.actions.employmentdetails.serviceSelect')}
              </span>
              <Select
                value={selection.serviceId}
                InputClassName='mt-2 mb-4'
                onChange={(id) => handleServiceChange(index, id)}
                options={Object.values(services).map((s) => ({
                  label: s.name,
                  value: s.id,
                }))}
                filterOption={(obj, string) => {
                  if (new RegExp(escapeRegExp(string), 'i').test(obj.label)) return true
                  return false
                }}
              />
            </div>
            <div className='col-6'>
              <Collapse isOpen={selection.serviceId && services[selection.serviceId]?.topics && Object.keys(services[selection.serviceId].topics).length > 0}>
                <span className='text-body'>
                  {translate('profile.actions.employmentdetails.topicSelect')}
                </span>
                <Select
                  value={selection.topicId}
                  InputClassName='mt-2 mb-4'
                  onChange={(id) => handleTopicChange(index, id)} // The `handleTopicChange` function will be updated below
                  options={
                    selection.serviceId
                      ? Object.values(services[selection.serviceId].topics).map((t) => ({
                        label: t.name,
                        value: t.id,
                      }))
                      : []
                  }
                  filterOption={(obj, string) => {
                    if (new RegExp(escapeRegExp(string), 'i').test(obj.label))
                      return true
                    return false
                  }}
                />
              </Collapse>
            </div>
          </div>
          {selectionsArray.length > 1 || selection.serviceId || selection.topicId ? (
            <IconErase size={20} color='#FF3E1D' onClick={() => removeSelection(index)} style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} />
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default TopicSelectionTeaching